import React from 'react'
// 状态
const statusArr = ['待审核', '已通过', '审核中', '未通过', '已取消报名', '预报名']
export default () => [
  {
    title: '课程名称',
    dataIndex: 'programName',
    key: 'programName',
    width: 200,
    render: (text, row, index) => {
      const obj = {
        children: text,
        props: {
          rowSpan: row.rowSpan
        },
      }
      return obj
    }
  },
  {
    title: '课程编码',
    dataIndex: 'programCode',
    key: 'programCode',
    width: 120,
    render: (text, row, index) => {
      const obj = {
        children: text,
        props: {
          rowSpan: row.rowSpan
        },
      }
      return obj
    }
  },
  {
    title: '班级名称',
    dataIndex: 'classInfoName',
    key: 'classInfoName',
    width:200
  },
  {
    title: '计划安排时间',
    dataIndex: 'planStartDate',
    key: 'planStartDate',
    render: (text, row, index) => (`${text} - ${row.planEndDate}`)
  },
  {
    title: '报名名称',
    dataIndex: 'applyName',
    key: 'applyName',
    width: 150,
  },
  {
    title: '限制人数',
    dataIndex: 'limitCount',
    key: 'limitCount',
    width:100,
  },
  {
    title: '已通过人数',
    dataIndex: 'passNumber',
    key: 'passNumber',
    width:100,
  },
  {
    title: '待审核人数',
    dataIndex: 'reviewNumber',
    key: 'reviewNumber',
    width:100,
  },
  {
    title: '报名状态',
    dataIndex: 'status',
    key: 'status',
    width:100,
    render: (text, row, index) => (statusArr[text])
  }
];
